import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "bg-gray-800 rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow duration-300 w-full" }
const _hoisted_2 = { class: "flex flex-row w-full" }
const _hoisted_3 = { class: "w-1/3 h-40 relative flex-shrink-0" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = {
  key: 1,
  class: "w-full h-full bg-gray-700 flex items-center justify-center"
}
const _hoisted_6 = { class: "p-4 flex flex-col justify-between w-2/3 flex-shrink-0" }
const _hoisted_7 = { class: "h-16 mb-2" }
const _hoisted_8 = { class: "text-sm font-semibold text-blue-400 line-clamp-2 hover:text-blue-300 transition-colors" }
const _hoisted_9 = { class: "flex items-center justify-between w-full mb-2" }
const _hoisted_10 = { class: "text-green-400 font-bold truncate" }
const _hoisted_11 = { class: "flex items-center justify-end" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "text-sm" }
const _hoisted_14 = { class: "flex items-center justify-between w-full" }
const _hoisted_15 = { class: "flex items-center text-purple-400 truncate" }
const _hoisted_16 = { class: "text-sm truncate" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.product.mainPicture)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _ctx.getImageUrl(_ctx.product.mainPicture),
              alt: _ctx.product.name,
              class: "w-full h-full object-cover"
            }, null, 8, _hoisted_4))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[1] || (_cache[1] = [
              _createElementVNode("span", { class: "text-gray-500" }, "Nema slike", -1)
            ])))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_router_link, {
            to: `/product/${_ctx.product.slug}`,
            class: "block"
          }, {
            default: _withCtx(() => [
              _createElementVNode("h3", _hoisted_8, _toDisplayString(_ctx.product.name), 1)
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.formatPrice(_ctx.product.price)) + " RSD ", 1),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleFollow && _ctx.toggleFollow(...args)), ["stop","prevent"])),
              class: _normalizeClass(["flex items-center text-red-400 hover:text-red-300 transition-colors", { 'opacity-70': _ctx.isLoading }]),
              disabled: _ctx.isLoading
            }, [
              _cache[2] || (_cache[2] = _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                class: "h-4 w-4 mr-1",
                viewBox: "0 0 24 24",
                stroke: "currentColor",
                fill: "currentColor"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
                })
              ], -1)),
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.product.followersCount), 1)
            ], 10, _hoisted_12)
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _cache[3] || (_cache[3] = _createElementVNode("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              class: "h-4 w-4 mr-1",
              viewBox: "0 0 24 24",
              stroke: "currentColor",
              fill: "none"
            }, [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
              }),
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M15 11a3 3 0 11-6 0 3 3 0 016 0z"
              })
            ], -1)),
            _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.product.city), 1)
          ]),
          _createVNode(_component_router_link, {
            to: `/profile/${_ctx.product.userId || ''}`,
            class: "text-sm text-purple-400 hover:text-purple-300 transition-colors truncate"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.product.username), 1)
            ]),
            _: 1
          }, 8, ["to"])
        ])
      ])
    ])
  ]))
}